import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import pkg from '../../../../package.json';
import { FooterSharedStyles, FooterWedge } from './FooterSharedStyles';
export const FooterWithLeftLogo = () => {
    return (_jsxs(FooterWithLeftLogoRoot, { children: [_jsxs(VersionDisplay, { children: ["v", pkg.version] }), _jsx(FooterWedge, {})] }));
};
const FooterWithLeftLogoRoot = styled.div `
    ${FooterSharedStyles}
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 32.5rem) {
        justify-content: flex-start;
    }
`;
const VersionDisplay = styled.div `
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: -0.02em;
`;
